import {
  DANGER_THRESHOLD_PERCENT,
  ROW_DANGER_CLASS_NAME,
  ROW_OK_CLASS_NAME,
  ROW_WARNING_CLASS_NAME,
  WARNING_THRESHOLD_PERCENT,
} from './const';
import { IContextWindowIndicatorViewData } from './types';

const THOUSAND = 1000;
const THOUSANDS_SUFFIX_THRESHOLD = 10000;

enum _ContextWindowStatus {
  Ok = 'Ok',
  Warning = 'Warning',
  Danger = 'Danger',
}

const STATUS_ROW_MODIFIERS: Record<_ContextWindowStatus, string> = {
  [_ContextWindowStatus.Ok]: ROW_OK_CLASS_NAME,
  [_ContextWindowStatus.Warning]: ROW_WARNING_CLASS_NAME,
  [_ContextWindowStatus.Danger]: ROW_DANGER_CLASS_NAME,
};

export const formatTokenCount = (value: number, thousandsSuffix: string): string =>
  value >= THOUSANDS_SUFFIX_THRESHOLD ? `${Math.floor(value / THOUSAND)}${thousandsSuffix}` : `${value}`;

export const formatContextTokens = (value: number, thousandsSuffix: string): string =>
  `${(value / THOUSAND).toFixed(1)}${thousandsSuffix}`;

const calculateFilledPercent = (usedContextTokens: number, contextWindow: number): number =>
  Math.min(100, Math.round((usedContextTokens / contextWindow) * 100));

const getContextWindowStatus = (percent: number): _ContextWindowStatus => {
  if (percent >= DANGER_THRESHOLD_PERCENT) {
    return _ContextWindowStatus.Danger;
  }
  if (percent >= WARNING_THRESHOLD_PERCENT) {
    return _ContextWindowStatus.Warning;
  }
  return _ContextWindowStatus.Ok;
};

const getStatusRowModifier = (status: _ContextWindowStatus): string => STATUS_ROW_MODIFIERS[status];

const isContextWindowFull = (status: _ContextWindowStatus): boolean => status === _ContextWindowStatus.Danger;

export const getViewData = (usedTokens: number, contextWindow: number): IContextWindowIndicatorViewData => {
  const percent = calculateFilledPercent(usedTokens, contextWindow);
  const status = getContextWindowStatus(percent);
  return {
    percent,
    rowModifier: getStatusRowModifier(status),
    isFull: isContextWindowFull(status),
  };
};
